import { render, staticRenderFns } from "./TablesMergeData.vue?vue&type=template&id=333a79d6&scoped=true"
import script from "./TablesMergeData.vue?vue&type=script&lang=js"
export * from "./TablesMergeData.vue?vue&type=script&lang=js"
import style0 from "./TablesMergeData.vue?vue&type=style&index=0&id=333a79d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a79d6",
  null
  
)

export default component.exports